export const DEVLINK_SCOPE_CLASS =
  "wf-devlink-f32c668238d143ab8fdb8498eb4890fe";
